import React, { useState } from 'react';

const isValidUrl = (url) => {
    if (!url) return true;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

const Step4AboutSocial = ({ data, onChange }) => {
    const [errors, setErrors] = useState({});

    const validateUrl = (field, value) => {
        const newErrors = { ...errors };
        if (value && !isValidUrl(value)) {
            newErrors[field] = 'URL must start with http:// or https://';
        } else {
            delete newErrors[field];
        }
        setErrors(newErrors);
    };

    const handleChange = (field, value) => {
        onChange(field, value);
    };

    const handleUrlChange = (field, value) => {
        validateUrl(field, value);
        onChange(field, value);
    };

    return (
        <div>
            <h2 className="step-title">About & Social Media</h2>
            <p className="step-subtitle">Share your story and connect with customers online.</p>

            <div className="form-group">
                <label className="form-label">About Us</label>
                <textarea
                    className="form-textarea"
                    placeholder="Tell customers about your business, values, and what makes you unique..."
                    value={data.about_us}
                    onChange={(e) => handleChange('about_us', e.target.value)}
                    maxLength={500}
                    rows={5}
                />
                <div className={`char-counter ${data.about_us.length >= 500 ? 'over-limit' : ''}`}>
                    {data.about_us.length}/500
                </div>
            </div>

            <div className="form-group">
                <label className="form-label">Mission Statement</label>
                <textarea
                    className="form-textarea"
                    placeholder="What is your business mission? (optional)"
                    value={data.mission_statement}
                    onChange={(e) => handleChange('mission_statement', e.target.value)}
                    maxLength={200}
                    rows={3}
                />
                <div className={`char-counter ${data.mission_statement.length >= 200 ? 'over-limit' : ''}`}>
                    {data.mission_statement.length}/200
                </div>
            </div>

            <hr className="section-divider" />

            <h3 className="step-title" style={{ fontSize: '1rem', marginBottom: '1rem' }}>
                Social Media Links
            </h3>

            {[
                { field: 'facebook_url', label: 'Facebook', placeholder: 'https://facebook.com/yourbusiness' },
                { field: 'twitter_url', label: 'Twitter / X', placeholder: 'https://twitter.com/yourbusiness' },
                { field: 'instagram_url', label: 'Instagram', placeholder: 'https://instagram.com/yourbusiness' },
                { field: 'linkedin_url', label: 'LinkedIn', placeholder: 'https://linkedin.com/company/yourbusiness' },
                { field: 'youtube_url', label: 'YouTube', placeholder: 'https://youtube.com/@yourbusiness' },
            ].map(({ field, label, placeholder }) => (
                <div className="form-group" key={field}>
                    <label className="form-label">{label}</label>
                    <input
                        type="url"
                        className={`form-input ${errors[field] ? 'error' : ''}`}
                        placeholder={placeholder}
                        value={data[field]}
                        onChange={(e) => handleUrlChange(field, e.target.value)}
                    />
                    {errors[field] && (
                        <span className="field-error">{errors[field]}</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Step4AboutSocial;
